import { render, staticRenderFns } from "./Vibrant.vue?vue&type=template&id=18b20a06&"
import script from "./Vibrant.vue?vue&type=script&lang=js&"
export * from "./Vibrant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports